<script setup lang="ts"></script>

<template>
  <UiButton
    class="border border-black text-black hover:bg-black hover:text-white"
    type="text"
  >
    <slot />
  </UiButton>
</template>
